import { render } from "./file.vue?vue&type=template&id=70588dc8&scoped=true&ts=true"
import script from "./file.vue?vue&type=script&lang=ts"
export * from "./file.vue?vue&type=script&lang=ts"

import "./file.vue?vue&type=style&index=0&id=70588dc8&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70588dc8"]])

export default __exports__